export type SignupBonusStatus = 'inactive' | 'active' | 'in_review' | 'completed' | 'expired';

export const SIGNUP_BONUS_STATUS_LABEL: Record<SignupBonusStatus, string> = {
  inactive: 'Inactive',
  active: 'Active',
  in_review: 'In review',
  completed: 'Completed',
  expired: 'Expired',
};

/** Human-readable inactivity rule from grantedAt → expiresAt span (not a calendar expiry). */
export function idleWindowLabel(
  grantedAt?: string | null,
  expiresAt?: string | null
): string {
  if (!grantedAt || !expiresAt) return '—';
  const ms = new Date(expiresAt).getTime() - new Date(grantedAt).getTime();
  if (!Number.isFinite(ms) || ms <= 0) return 'N-day idle → login';
  const days = Math.max(1, Math.round(ms / 86400000));
  return `${days}d idle → login check`;
}

export function inactivityRuleText(input: {
  status: SignupBonusStatus;
  grantedAt?: string | null;
  expiresAt?: string | null;
  expiredAt?: string | null;
}): string {
  if (!input.grantedAt) return 'Starts after the player claims';
  if (input.status === 'expired') {
    return input.expiredAt ? 'Expired (grant recalled)' : 'Expired';
  }
  if (input.status === 'completed') return 'N/A — already completed';
  if (input.status === 'in_review') {
    return 'Locked in review — does not expire until the first payout is approved';
  }
  const ms = input.expiresAt
    ? new Date(input.expiresAt).getTime() - new Date(input.grantedAt).getTime()
    : NaN;
  const days = Number.isFinite(ms) && ms > 0 ? Math.max(1, Math.round(ms / 86400000)) : null;
  const window = days != null ? `${days}-day` : 'Configured';
  return `${window} idle window — next login expires only if no game transfers in that window, and only after full grant recall`;
}
